import React from 'react';
import { states } from '@/constants/lifecycle';
import BackButton from '@/components/buttons/BackButton';
import CloseButton from '@/components/buttons/CloseButton';
import SaveButton from '@/components/buttons/SaveButton';
import RequestTerms from './RequestTerms';
import { validateRequestSection } from '../helper';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const AboutInfoActions = ({
  category,
  code,
  compact,
  goBack,
}) => {
  const {
    request, terms, workflow, saveStatus, sourceUrl,
  } = Selectors.useAboutInfoActions({ category, code });
  const cancelRequest = Events.useDestroyRequests();
  const updateProperties = Events.useUpdateRequestProperties(category, { code });
  const postData = Events.useCreateRequest(category, { code });

  const submitForm = () => {
    const saveErrors = validateRequestSection(request, workflow, 'about');

    if (saveErrors.length > 0) {
      updateProperties({ properties: { saveErrors } });
    } else {
      postData();
    }
  };

  return (
    <div className="aridhia-request-access-wizard-actions aridhia-tab-actions">
      <RequestTerms category={category} code={code} compact={compact} />
      <div className="actions">
        <CloseButton
          onClick={() => cancelRequest({
            items: [{ code, isNew: true, steps: { sourceUrl } }],
            isArchival: false,
            silent: true,
          })}
          disabled={saveStatus === states.PENDING}
        />
        <BackButton onClick={goBack} disabled={saveStatus === states.PENDING} iconOnly={compact} />
        <SaveButton
          iconOnly={compact}
          inProgress={saveStatus === states.PENDING}
          messageId="actions.submit"
          minimumDataEntryMet={terms}
          onClick={submitForm}
        />
      </div>
    </div>
  );
};

export default AboutInfoActions;
